import "./footer.comp.scss";
import { useContext } from "react";
import { LanguageContext } from "../../contexts/language/language.context";

import enFlag from "../../assets/emojis/flags/en-flag.png";
import frFlag from "../../assets/emojis/flags/fr-flag.png";
import { useResponsive } from "../../hooks/responsive.hook";

/* ICONS */
import PhoneIcon from "@mui/icons-material/Phone";
import facebookIcon from "../../assets/icons/contacts/facebook.png";
import gmailIcon from "../../assets/icons/contacts/gmail.png";
import linkedinIcon from "../../assets/icons/contacts/linkedin.png";
import skypeIcon from "../../assets/icons/contacts/skype.png";
import githubIcon from "../../assets/icons/contacts/github.png";

const Footer = () => {
  const { l, changeLanguage } = useContext(LanguageContext);
  const { currentScreen } = useResponsive();

  const LeftSide = () => (
    <>
      <div className="left-hand">
        <p className="copyright">{l.footer.copyright}</p>

        <div className="language-field">
          <div className="language-flag">
            <img alt="image" src={getFlag(l.code)} />
          </div>

          <label htmlFor="language">{l.footer.language} </label>

          <select
            name="language"
            value={l.code}
            id="language"
            onChange={(e) => changeLanguage(e.target.value as "en" | "fr")}
          >
            <option value="en">English</option>
            <option value="fr">Français</option>
          </select>
        </div>
      </div>
    </>
  );

  return (
    <footer className="footer-container">
      {currentScreen.size !== "small" && <LeftSide />}
      <div className="right-hand">
        <p className="telephones">
          <PhoneIcon
            sx={{
              width: "1.5rem",
              height: "auto",
              position: "relative",
              top: "0.2rem",
            }}
          />{" "}
          +261 32 56 283 64
          <span style={{ margin: "0 0.5rem" }}> / </span> +261 34 50 355 66
        </p>
        <div className="social-icons">
          <a
            href="https://www.facebook.com/brillant.jeanfelicien.96"
            target="_blank"
          >
            <img src={facebookIcon} alt="facebook" />
          </a>

          <a href="mailto:jbrillantf@gmail.com" target="_blank">
            <img src={gmailIcon} alt="gmail" />
          </a>
          <a
            href="https://www.linkedin.com/in/fenohasina-jean-f%C3%A9licien-brillant-433474241/"
            target="_blank"
          >
            <img src={linkedinIcon} alt="linkedin" />
          </a>
          <a href="skype:live:.cid.10b6edffeca2cec1" target="_blank">
            <img src={skypeIcon} alt="skype" />
          </a>
          <a href="https://github.com/bri11ant" target="_blank">
            <img src={githubIcon} alt="github" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

function getFlag(code: "en" | "fr") {
  switch (code) {
    case "fr":
      return frFlag;
    default:
      return enFlag;
  }
}
